<div class="tooltipWrapper">
    <div class="tooltipContent">
        <ng-container #tooltipContentContainer />
    </div>
</div>
